export default "__VITE_ASSET__nfcI0fi1__"